import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  total: 0,
  regular_total: 0,
  quantity: 0
};


const calculateTotals = (products) => {
  let total = 0;
  let quantity = 0;
  let regular_total = 0;
  products.forEach(p => {
    quantity += p.quantity;
    total += (p.quantity * p.user_price);
    regular_total += (p.quantity * p.retail_price);
  });
  return [total, quantity, regular_total];
}

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCartState: (state, action) => {
      state.products = Array.isArray(action.payload?.products) ? action.payload.products : [];
      state.total = Number(action.payload?.total || 0);
      state.regular_total = Number(action.payload?.regular_total || 0);
      state.quantity = Number(action.payload?.quantity || 0);
    },
    addToCart: (state, action) => {
      if (action.payload.type === "simple") {
        if (state.products.findIndex(p => p.sku === action.payload.sku) !== -1) {
          state.products[state.products.findIndex(p => p.sku === action.payload.sku)].quantity += action.payload.quantity;
        } else {
          state.products.push(action.payload);
        }
      } else if (action.payload.type === "custom") {
        if (state.products.findIndex(p => JSON.stringify(current(p).params) === JSON.stringify(action.payload.params)) !== -1) {
          state.products[state.products.findIndex(p => JSON.stringify(current(p).params) === JSON.stringify(action.payload.params))].quantity += action.payload.quantity;
        } else {
          state.products.push(action.payload);
        }
      }
      const [total, quantity, regular_total] = calculateTotals(state.products);
      state.total = Number(total.toFixed(2));
      state.regular_total = Number(regular_total.toFixed(2));
      state.quantity = quantity;
    },
    removeFromCart: (state, action) => {
      if (action.payload.type === "simple") {
        state.products = state.products.filter(p => { return p.sku !== action.payload.sku });
      } else if (action.payload.type === "custom") {
        state.products = state.products.filter(p => { return JSON.stringify(current(p).params) !== JSON.stringify(action.payload.params) });
      }
      const [total, quantity, regular_total] = calculateTotals(state.products);
      state.total = Number(total.toFixed(2));
      state.regular_total = Number(regular_total.toFixed(2));
      state.quantity = quantity;

    },
    updateCartQuantity: (state, action) => {
      if (action.payload.item.type === "simple") {
        state.products[state.products.findIndex(p => p.sku === action.payload.item.sku)].quantity = action.payload.quantity;
      } else if (action.payload.item.type === "custom") {
        state.products[state.products.findIndex(p => JSON.stringify(current(p).params) === JSON.stringify(action.payload.item.params))].quantity = action.payload.quantity;
      }
      const [total, quantity, regular_total] = calculateTotals(state.products);
      state.total = Number(total.toFixed(2));
      state.regular_total = Number(regular_total.toFixed(2));
      state.quantity = quantity;
    },
    updateCartItem: (state, action) => {
      state.products[action.payload.index] = action.payload.product
      const [total, quantity, regular_total] = calculateTotals(state.products);
      state.total = Number(total.toFixed(2));
      state.regular_total = Number(regular_total.toFixed(2));
      state.quantity = quantity;
    },
    updateCartItemNote: (state, action) => {
      state.products[action.payload.index].notes = action.payload.note;
    },
    clearCart: (state) => {
      state.products = [];
      state.total = 0;
      state.regular_total = 0;
      state.quantity = 0;
    }
  },
});




export const selectCart = (state) => state.cart;

export const { setCartState, addToCart, removeFromCart, updateCartQuantity, clearCart, updateCartItem, updateCartItemNote } = cartSlice.actions

export default cartSlice.reducer;
